import { Box, CardHeader, Paper, Tab, Tabs } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { HttpClient } from "../../../web-services/http-client";
import "./felhasznalokezelo-page.scss";
import { FelhasznalokezeloTable } from "../../common/felhasznalokezelo-table";
import { IUserData } from "../../../web-services/models/user-data";
import { IRoleData } from "../../../web-services/models/role-data";
import { FelhasznalokezeloEditDialog } from "./felhasznalokezelo-edit-dialog";
import { FelhasznalokezeloCreateDialog } from "./felhasznalokezelo-create-dialog";
import { FelhasznalokezeloRemoveDialog } from "./felhasznalokezelo-confirm-dialog";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function FelhasznalokezeloPage(props: { httpClient: HttpClient })
{

    const [errorMsg, setErrorMsg] = useState<string>();
    const [errorCategoryMsg, setErrorCategoryMsg] = useState<string>();
    const [isSendingRequest, setIsSendingRequest] = useState<boolean>(true);
    const [progressDialogOpened, setProgressDialogOpened] = useState<boolean>(false);
    const [selectedUser, setSelectedUser] = useState<IUserData>();
    const [userDialogOpened, setUserDialogOpened] = useState<boolean>(false);
    const [userRemoveOpened, setUserRemoveDialogOpened] = useState<boolean>(false);
    const [userCreaterDialogOpened, setUserCreaterDialogOpened] = useState<boolean>(false);
    const [roleData, setRoleData] = useState<IRoleData[]>([]);


    const [tableData, setTableData] = useState<IUserData[]>([]);

    useEffect(() =>
    {
        fetchDataForRole();
        if (!isSendingRequest) return;
        setProgressDialogOpened(true);

        const fetchData = async () =>
        {
            setErrorMsg(undefined);
            setErrorCategoryMsg(undefined);
            try
            {
                let data = (await props.httpClient.get<IUserData[]>("user/get-felhasznalok", "", 15000)).data;
                setTableData(data || []);
                setProgressDialogOpened(false);
            }
            catch (err: any)
            {
                console.log(err);

                if (err.message === "Nem várt hiba történt.")
                {
                    setErrorCategoryMsg("Kapcsolati hiba");
                    setErrorMsg("Kérjük, próbálja újra az adatlekérést.");
                }
                else
                {
                    setErrorMsg(err.message);
                }
            }

            setIsSendingRequest(false);
        };

        fetchData().catch(console.error);

    }, [isSendingRequest]);
    useEffect(() =>
    {
        if (userCreaterDialogOpened && roleData.length === 0)
        {
            fetchDataForRole();
        }
    }, [userCreaterDialogOpened, roleData]);

    const handleModifyButtonClick = (user: IUserData) =>
    {
        setSelectedUser(user);
        setUserDialogOpened(true);
    };
    const handleNewButtonClick = () =>
    {
        setUserCreaterDialogOpened(true);
    };
    const handleRemoveButtonClick = (user: IUserData) =>
    {
        setSelectedUser(user);
        setUserRemoveDialogOpened(true);
    };
    const handleSaveSuccess = () =>
    {
        setUserDialogOpened(false);
        setUserCreaterDialogOpened(false);
        setUserRemoveDialogOpened(false);
        setIsSendingRequest(true);
    };
    const fetchDataForRole = () =>
    {
        if (roleData.length > 0) return;
        const fetchData = async () =>
        {
            setErrorMsg(undefined);
            setErrorCategoryMsg(undefined);
            try
            {
                let data = (await props.httpClient.get<IRoleData[]>("role/get-role-data", "", 15000)).data;
                setRoleData(data || []);
            }
            catch (err: any)
            {
                console.log(err);

                if (err.message === "Nem várt hiba történt.")
                {
                    setErrorCategoryMsg("Kapcsolati hiba");
                    setErrorMsg("Kérjük, próbálja újra a sablonok letöltését.");
                }
                else
                {
                    setErrorMsg(err.message);
                }
            }
        };

        fetchData().catch(console.error);
    };

    return (
        <div className="scrollable-container">
            <FelhasznalokezeloEditDialog
                onSaveSuccess={handleSaveSuccess}
                httpClient={props.httpClient}
                user={selectedUser}
                open={userDialogOpened}
                roleok={roleData}
                onClose={() => setUserDialogOpened(false)}
            />
            <FelhasznalokezeloRemoveDialog
                onSaveSuccess={handleSaveSuccess}
                httpClient={props.httpClient}
                user={selectedUser}
                open={userRemoveOpened}
                onClose={() => setUserRemoveDialogOpened(false)}
            />
            <FelhasznalokezeloCreateDialog
                onSaveSuccess={handleSaveSuccess}
                httpClient={props.httpClient}
                open={userCreaterDialogOpened}
                onClose={() => setUserCreaterDialogOpened(false)}
            />
            <Paper className="main-paper">
                <CardHeader title="Felhasználók" />
                <FelhasznalokezeloTable data={tableData} onModifyButtonClick={handleModifyButtonClick} onCreateNewButtonClick={handleNewButtonClick} onRemoveButtonClick={handleRemoveButtonClick} />
            </Paper>
        </div>
    );
}
